<template>
  <div id="OptionInfoBox">
    <ul id="OptionInfo">
      <li>{{ $t('PEER.ResultOptionInfo.average') }}</li>
      <li>{{ $t('PEER.ResultOptionInfo.outlier') }}</li>
      <li>{{ $t('PEER.ResultOptionInfo.highAchievement') }}</li>
      <li>{{ $t('PEER.ResultOptionInfo.reliability') }}</li>
      <li>{{ $t('PEER.ResultOptionInfo.feedback') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ResultOptionInfo',
};
</script>

<style lang="scss">
#OptionInfoBox {
  border-left: 1.5px solid $MAIN-COLOR;
  border-right: 1.5px solid $MAIN-COLOR;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-radius: 5px;
  width: 60%;

  ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 0 0 20px;
  }
}
</style>
